import $ from "jquery";
import './app'
import './instant'
import {checkSymbols, parseStringFloat, showToastNotify, TOASTR_ERROR} from './helpers'
import {rates} from './instant'

let currentExchangeRates,
    repayType,
    exchangeRates,
    timeoutHandle,
    timerState = false,
    needUpdate = false,
    balanceRepayCalcType;

const NON_VISIBLE = 'd-none',
      BORDER_ACTIVE = 'border-radius-green-active';
const RUB_FIAT = 'RUB',
      UAH_FIAT = 'UAH',
      USD_CURRENCY = 'usd',
      BTC_CURRENCY = 'BTC',
      ETH_CURRENCY = 'ETH',
      USDT_CURRENCY = 'USDT',
      FIAT_RECALC_TYPE = 'fiat',
      CRYPTO_RECALC_TYPE = 'crypto',
      OPEN_IN_WALLET_ACTION = $('#crypto-repay-open-in-wallet');

let fiatRepayCalcType = USD_CURRENCY,
    cryptoRepayCalcType = USD_CURRENCY;

const FIAT_REPAY_PERCENT = 0.05;
const USDT_REPAY_PERCENT = 0.01;

const BALANCE_REPAY_TYPE = 'balance-repay',
      FIAT_REPAY_TYPE = 'fiat-repay',
      CRYPTO_REPAY_TYPE = 'crypto-repay';

const BALANCE_REPAY_EXPAND = $('#balance-repay-expand'),
      FIAT_REPAY_EXPAND = $('#fiat-repay-expand'),
      CRYPTO_REPAY_EXPAND = $('#crypto-repay-expand'),
      BALANCE_REPAY_BOX = $('#balance-repay-box'),
      FIAT_REPAY_BOX = $('#fiat-repay-box'),
      CRYPTO_REPAY_BOX = $('#crypto-repay-box');

// balance, loan values
const USED_LOAN_LIMIT = $('#used-loan-limit');

const USED_LOAN_LIMIT_AMOUNT = parseStringFloat(USED_LOAN_LIMIT.text())

const showRepayExpand = () => {
    needUpdate = true;
    repayType = '';
    const repayRadioValue = $("input[name=repay]:checked").val();
    if (repayRadioValue === BALANCE_REPAY_TYPE) {
        $('#balance-repay-usd-value').val(USED_LOAN_LIMIT_AMOUNT);
        setBalanceRepayAmount();
        BALANCE_REPAY_EXPAND.removeClass(NON_VISIBLE);
        FIAT_REPAY_EXPAND.addClass(NON_VISIBLE);
        CRYPTO_REPAY_EXPAND.addClass(NON_VISIBLE);
        repayType = BALANCE_REPAY_TYPE;
        BALANCE_REPAY_BOX.addClass(BORDER_ACTIVE);
        CRYPTO_REPAY_BOX.removeClass(BORDER_ACTIVE);
    }
    if (repayRadioValue === CRYPTO_REPAY_TYPE) {
        $('#crypto-repay-usd-value').val(USED_LOAN_LIMIT_AMOUNT);
        setCryptoRepayAmount(USD_CURRENCY);
        CRYPTO_REPAY_EXPAND.removeClass(NON_VISIBLE);
        BALANCE_REPAY_EXPAND.addClass(NON_VISIBLE);
        FIAT_REPAY_EXPAND.addClass(NON_VISIBLE);
        repayType = CRYPTO_REPAY_TYPE;
        CRYPTO_REPAY_BOX.addClass(BORDER_ACTIVE);
        BALANCE_REPAY_BOX.removeClass(BORDER_ACTIVE);
    }
    if (repayRadioValue === FIAT_REPAY_TYPE) {
        $('#fiat-repay-usd-value').val(USED_LOAN_LIMIT_AMOUNT);
        hideFiatRequisiteBlock();
        setFiatRepayAmount(USD_CURRENCY);
        FIAT_REPAY_EXPAND.removeClass(NON_VISIBLE);
        BALANCE_REPAY_EXPAND.addClass(NON_VISIBLE);
        CRYPTO_REPAY_EXPAND.addClass(NON_VISIBLE);
        repayType = FIAT_REPAY_TYPE;
        CRYPTO_REPAY_BOX.removeClass(BORDER_ACTIVE);
        BALANCE_REPAY_BOX.removeClass(BORDER_ACTIVE);
    }
}

const showConfirmBalanceRepay = () => {
    $('#btn-confirm-balance-repay').prop('disabled', false);
    $('#loanRepayment').modal('hide');
    const btcVal = $('#balance-repay-btc-value').val();
    const usdVal = $('#balance-repay-usd-value').val();
    $('#balance-repay-btc-amount').text(btcVal);
    $('#balance-repay-usd-amount').text(usdVal);
    $('#confirmBalanceRepay').modal('show');
}

const showSuccessLoanRepayment = (repaymentUsd, repaymentPercent, repaymentLoan, loanLimitValue) => {
    $('#confirmBalanceRepay').modal('hide');
    $('#repayment-usd').text(repaymentUsd);
    $('#repayment-percent').text(repaymentPercent);
    $('#repayment-loan').text(repaymentLoan);
    $('#repay-loan-limit-value').text(loanLimitValue);
    $('#successLoanRepayment').modal('show');
}

const showSuccessRequestRepay = () => {
    $('#loanRepayment').modal('hide');
    $('#requestLoanRepay').modal('show');
}

const initRepayTypeTimer = (type) => {
    timerState = true;
    let finalTime = 300000
    const left = $('#' + type + '-timer-left')
    const millisecondsInMinute = 60000
    timeoutHandle = window.setInterval(function () {
        const nowLeft = Math.trunc(finalTime / millisecondsInMinute)
        const seconds = Math.floor((finalTime / 1000) % 60);
        finalTime -= 1000;
        left.html(`${nowLeft} min ${seconds} sec`)
        if (finalTime <= 0) {
            fillRepayData(type)
        }
    }, 1000);
}

const repayRateUpdate = (type) => {
    fillRepayData(type);
}

const getCurrentRates = () => {
    currentExchangeRates = rates;
    exchangeRates = rates;
}

const getCurrencyRateUpdated = (code) => {
    return currentExchangeRates[code]['rateUpdated']
}

const confirmCryptoRepay = () => {
    const qrCodeBox = $('#qr-code-url');
    if (!qrCodeBox.hasClass(NON_VISIBLE)) {
        qrCodeBox.addClass(NON_VISIBLE);
    }
    const cryptoCurrency = getCryptoCurrency();
    const cryptoAmount = $('#crypto-repay-crypto-value').val();
    const usdAmount = $('#crypto-repay-usd-value').val();
    const walletCurrency = cryptoCurrency.toLowerCase();
    const cryptoPropVal = $('#crypto-repay-' + walletCurrency + '-wallet').val();
    const exchangeRateUpdate = getCurrencyRateUpdated(cryptoCurrency)
    let data = {
        'repayment_type': repayType,
        'currency': cryptoCurrency,
        'amount': cryptoAmount,
        'usd_amount': usdAmount,
        'requisite_detail': cryptoPropVal,
        'updated_at': exchangeRateUpdate
    }
    let url = '/repayment';
    sendRepayQuery(url, data, false);
}

const loanRepayment = () => {
    getCurrentRates();
    $('input[name=repay]').attr('checked', false);
    $('#loanRepayment').modal('show');
}

const setBalanceRepayAmount = () => {
    const btcRate = exchangeRates['BTC']['rate'];
    const repayUsedLoan = $('#repay-used-loan');
    repayUsedLoan.text(USED_LOAN_LIMIT_AMOUNT);
    const balanceRepayBtc = $('#balance-repay-btc-value');
    const balanceRepayUsd = $('#balance-repay-usd-value');
    let balanceRepayUsdVal = balanceRepayUsd.val();
    if (balanceRepayUsdVal > USED_LOAN_LIMIT_AMOUNT) {
        balanceRepayUsdVal = USED_LOAN_LIMIT_AMOUNT;
    }
    const repayRateBox = $('#repay-exchange-rate');
    const repayRateValue = Math.round(1 / btcRate * 100) / 100;
    repayRateBox.text(repayRateValue);
    balanceRepayUsd.val(balanceRepayUsdVal);
    const btcRepayAmount = (balanceRepayUsdVal * btcRate).toFixed(8);
    balanceRepayBtc.val(btcRepayAmount);
    $('#balance-repay-amount').text(balanceRepayUsdVal)
}

const setFiatAdditional = (currency, rubRate, uahRate) => {
    let fiatRate;
    if (currency === RUB_FIAT) {
        fiatRate = Math.round(rubRate * 100) / 100;
    }
    if (currency === UAH_FIAT) {
        fiatRate = Math.round(uahRate * 100) / 100;
    }
    const fiatRepayRateBox = $('#fiat-repay-exchange-rate');
    const fiatRepayCurrency = $('#fiat-repay-currency');
    fiatRepayRateBox.text(fiatRate);
    fiatRepayCurrency.text(currency.toUpperCase());
    const repayUsedLoan = $('#fiat-repay-usd-loan');
    repayUsedLoan.text(USED_LOAN_LIMIT_AMOUNT);
}

const getFiatRepayRate = (fiatRate) => {
    const fiatRateAmount = parseFloat(fiatRate)
    return fiatRateAmount * FIAT_REPAY_PERCENT + fiatRateAmount;
}

const getPercentRepayRate = (rate) => {
    const cryptoRate = parseFloat(rate)
    return cryptoRate * USDT_REPAY_PERCENT + cryptoRate;
}

const setFiatRepayAmount = (fiatRepayCalcType) => {
    const fiatCurrency = getFiatCurrency();
    const rubRate = getFiatRepayRate(currentExchangeRates['RUB']['rate']);
    const uahRate = getFiatRepayRate(currentExchangeRates['UAH']['rate']);
    setFiatAdditional(fiatCurrency, rubRate, uahRate);
    const fiatAmountBox = $('#fiat-repay-fiat-value');
    const usdAmountBox = $('#fiat-repay-usd-value');
    let fiatAmount = fiatAmountBox.val();
    let usdAmount = usdAmountBox.val();
    if (usdAmount > USED_LOAN_LIMIT_AMOUNT) {
        usdAmount = USED_LOAN_LIMIT_AMOUNT
    }
    if (fiatRepayCalcType === FIAT_RECALC_TYPE) {
        if (fiatCurrency === RUB_FIAT) {
            usdAmount = Math.round(fiatAmount / rubRate * 100) / 100;
        }
        if (fiatCurrency === UAH_FIAT) {
            usdAmount = Math.round(fiatAmount / uahRate * 100) / 100;
        }

    } else if (fiatRepayCalcType === USD_CURRENCY) {
        if (fiatCurrency === RUB_FIAT) {
            fiatAmount = Math.round(usdAmount * rubRate * 100) / 100;
        }
        if (fiatCurrency === UAH_FIAT) {
            fiatAmount = Math.round(usdAmount * uahRate * 100) / 100;
        }
    }
    if (usdAmount > USED_LOAN_LIMIT_AMOUNT) {
        const recalcValues = recalcFiatTypeRepay(fiatCurrency, rubRate, uahRate)
        usdAmountBox.val(recalcValues['usdAmount']);
        fiatAmountBox.val(recalcValues['fiatAmount']);
        usdAmount = recalcValues['usdAmount']
    } else {
        usdAmountBox.val(usdAmount);
        fiatAmountBox.val(fiatAmount);
    }
    $('#fiat-repay-amount').text(usdAmount);
    showFiatRequisitesBlock(fiatCurrency);
}

const recalcFiatTypeRepay = (fiatCurrency, rubRate, uahRate) => {
    let fiatAmount;
    let usdAmount = USED_LOAN_LIMIT_AMOUNT
    if (fiatCurrency === RUB_FIAT) {
        fiatAmount = Math.round(usdAmount * rubRate * 100) / 100;
    }
    if (fiatCurrency === UAH_FIAT) {
        fiatAmount = Math.round(usdAmount * uahRate * 100) / 100;
    }
    return {
        'usdAmount': usdAmount,
        'fiatAmount': fiatAmount,
    }
}

const recalcCryptoTypeRepay = (cryptoCurrency, btcRate, ethRate, usdtRate) => {
    let cryptoAmount;
    let usdAmount = USED_LOAN_LIMIT_AMOUNT
    if (cryptoCurrency === ETH_CURRENCY) {
        cryptoAmount = (usdAmount * ethRate).toFixed(8);
    }
    if (cryptoCurrency === BTC_CURRENCY) {
        cryptoAmount = (usdAmount * btcRate).toFixed(8);
    }
    if (cryptoCurrency === USDT_CURRENCY) {
        cryptoAmount = (usdAmount * usdtRate).toFixed(2);
    }
    return {
        'usdAmount': usdAmount,
        'cryptoAmount': cryptoAmount,
    }
}

const recalcBalanceTypeRepay = (btcRate) => {
    let btcAmount;
    let usdAmount = USED_LOAN_LIMIT_AMOUNT;
    btcAmount = (usdAmount * btcRate).toFixed(8);

    return {
        'usdAmount': usdAmount,
        'btcAmount': btcAmount,
    }
}

const showFiatRequisitesBlock = (fiatCurrencyType) => {
    const selectedFiatType = $('#' + fiatCurrencyType + '-select-fiat-type :selected').val();
    $('#' + fiatCurrencyType + '-type-block').removeClass(NON_VISIBLE);
    $('#' + fiatCurrencyType + '-prop-block').removeClass(NON_VISIBLE);
    $('#requisite-' + selectedFiatType + '-prop').removeClass(NON_VISIBLE);
    $('#copy-' + selectedFiatType + '-action').removeClass(NON_VISIBLE);
}

const getCryptoCurrency = () => {
    return $("#crypto-repay-select :selected").val();
}

const setCryptoAdditional = (cryptoCurrency, btcRate, ethRate, usdtRate) => {
    const USDT_ADD_BLOCK = $('#usdt-add-block')
    const CRYPTO_ADD_BLOCK = $('#crypto-add-block')
    let cryptoRate;
    $('#crypto-repay-used-loan').text(USED_LOAN_LIMIT_AMOUNT);
    USDT_ADD_BLOCK.addClass(NON_VISIBLE)
    if (cryptoCurrency === BTC_CURRENCY || cryptoCurrency === ETH_CURRENCY) {
        CRYPTO_ADD_BLOCK.removeClass(NON_VISIBLE)
        if (cryptoCurrency === BTC_CURRENCY) {
            cryptoRate = Math.round(1 / btcRate * 100) / 100;
        }
        if (cryptoCurrency === ETH_CURRENCY) {
            cryptoRate = Math.round(1 / ethRate * 100) / 100;
        }
        $('#crypto-repay-exchange-rate').text(cryptoRate);
        $('#crypto-repay-currency').text(cryptoCurrency.toUpperCase());
    }
    else {
        USDT_ADD_BLOCK.removeClass(NON_VISIBLE)
        CRYPTO_ADD_BLOCK.addClass(NON_VISIBLE)
        cryptoRate = Math.round(usdtRate * 100) / 100;
        $('#usdt-repay-exchange-rate').text(cryptoRate)
    }
}

const setCryptoRepayAmount = (cryptoRepayCalcType) => {
    const cryptoCurrency = getCryptoCurrency();
    if (cryptoCurrency === BTC_CURRENCY) {
        OPEN_IN_WALLET_ACTION.removeClass(NON_VISIBLE)
    }
    const btcRate = currentExchangeRates['BTC']['rate'];
    const ethRate = currentExchangeRates['ETH']['rate'];
    const usdtRate = getPercentRepayRate(currentExchangeRates['USDT']['rate']);
    setCryptoAdditional(cryptoCurrency, btcRate, ethRate, usdtRate);
    const cryptoAmountBox = $('#crypto-repay-crypto-value');
    const usdAmountBox = $('#crypto-repay-usd-value');
    let cryptoAmount = cryptoAmountBox.val();
    let usdAmount = usdAmountBox.val();
    if (usdAmount > USED_LOAN_LIMIT_AMOUNT) {
        usdAmount = USED_LOAN_LIMIT_AMOUNT
    }
    if (cryptoRepayCalcType === CRYPTO_RECALC_TYPE) {
        if (cryptoCurrency === BTC_CURRENCY) {
            usdAmount = Math.round(cryptoAmount / btcRate * 100) / 100;
        }
        if (cryptoCurrency === ETH_CURRENCY) {
            usdAmount = Math.round(cryptoAmount / ethRate * 100) / 100;
        }
        if (cryptoCurrency === USDT_CURRENCY) {
            usdAmount = Math.round(cryptoAmount / usdtRate * 100) / 100;
        }

    } else if (cryptoRepayCalcType === USD_CURRENCY) {
        if (cryptoCurrency === ETH_CURRENCY) {
            cryptoAmount = (usdAmount * ethRate).toFixed(8);
        }
        if (cryptoCurrency === BTC_CURRENCY) {
            cryptoAmount = (usdAmount * btcRate).toFixed(8);
        }
        if (cryptoCurrency === USDT_CURRENCY) {
            cryptoAmount = Math.round(usdAmount * usdtRate * 100) / 100;
        }
    }
    showCryptoRequisitesBlock(cryptoCurrency);
    needDisplayOpenInWallet();

    if (usdAmount > USED_LOAN_LIMIT_AMOUNT) {
        const recalcValues = recalcCryptoTypeRepay(cryptoCurrency, btcRate, ethRate, usdtRate)
        usdAmountBox.val(recalcValues['usdAmount']);
        cryptoAmountBox.val(recalcValues['cryptoAmount']);
        usdAmount = recalcValues['usdAmount']
    } else {
        usdAmountBox.val(usdAmount);
        cryptoAmountBox.val(cryptoAmount);
    }
    $('#crypto-repay-amount').text(usdAmount);
}

const needDisplayOpenInWallet = (cryptoCurrency) => {
    if (cryptoCurrency === BTC_CURRENCY) {
        $('#open-in-wallet').removeClass(NON_VISIBLE);
    }
}

const hideCryptoRequisiteBlock = () => {
    if (!($('#props-btc-block').hasClass(NON_VISIBLE))) {
        $('#props-btc-block').addClass(NON_VISIBLE);
    }
    if (!($('#props-eth-block').hasClass(NON_VISIBLE))) {
        $('#props-eth-block').addClass(NON_VISIBLE);
    }
    if (!($('#props-usdt-block').hasClass(NON_VISIBLE))) {
        $('#props-usdt-block').addClass(NON_VISIBLE);
    }
}

const showCryptoRequisitesBlock = (type) => {
    const cryptoType = type.toLowerCase();
    $('#props-' + cryptoType + '-block').removeClass(NON_VISIBLE);
}

const fillRepayData = (type) => {
    currentExchangeRates = exchangeRates
    if (type === BALANCE_REPAY_TYPE) {
        setBalanceRepayAmount()
    }
    if (type === CRYPTO_REPAY_TYPE) {
        setCryptoRepayAmount(cryptoRepayCalcType);
    }
    if (type === FIAT_REPAY_TYPE) {
        setFiatRepayAmount(fiatRepayCalcType);
    }
}

const checkRepayModalState = () => {
    if (!$('#loanRepayment').hasClass('show')) {
        needUpdate = false;
    }
}

const successLoanRepaymentModalHidden = () => {
    $('#successLoanRepayment').on('hidden.bs.modal', function (e) {
        location.reload();
    })
}

const repayModalHidden = () => {
    $('#loanRepayment').on('hidden.bs.modal', function (e) {
        repayType = false;
        needUpdate = false;
        hideRepayExpand();
    })
}

function requestRepayModalHidden() {
    $('#requestLoanRepay').on('hidden.bs.modal', function (e) {
        window.location.reload();
    })
}

const repayModalShow = () => {
    $('#loanRepayment').on('show.bs.modal', function (e) {
        getCurrentRates();
    })
}

const hideRepayExpand = () => {
    document.getElementById('crypto-repay').checked = false;
    document.getElementById('balance-repay').checked = false;
    // document.getElementById('fiat-repay').checked = false;
    BALANCE_REPAY_EXPAND.addClass(NON_VISIBLE);
    // FIAT_REPAY_EXPAND.addClass(NON_VISIBLE);
    CRYPTO_REPAY_EXPAND.addClass(NON_VISIBLE);
    BALANCE_REPAY_BOX.removeClass(BORDER_ACTIVE);
    CRYPTO_REPAY_BOX.removeClass(BORDER_ACTIVE);
}

const checkUsdAmountValue = (type) => {
    const selector = $('#' + type + '-repay-usd-value');
    const usdAmountLength = selector.val().length;
    if (usdAmountLength > 8) {
        selector.val(USED_LOAN_LIMIT_AMOUNT)
    }
}

const balanceRepayRecalc = () => {
    const btcRate = currentExchangeRates['BTC']['rate'];
    const btcAmountBox = $('#balance-repay-btc-value');
    const usdAmountBox = $('#balance-repay-usd-value');
    let btcAmount = btcAmountBox.val();
    let usdAmount = usdAmountBox.val();

    if (balanceRepayCalcType === CRYPTO_RECALC_TYPE) {
        usdAmount = Math.round(btcAmount / btcRate * 100) / 100;
    } else if (balanceRepayCalcType === USD_CURRENCY && usdAmount <= USED_LOAN_LIMIT_AMOUNT) {
        btcAmount = (usdAmount * btcRate).toFixed(8);
    }

    if (usdAmount > USED_LOAN_LIMIT_AMOUNT) {
        const recalcAmount = recalcBalanceTypeRepay(btcRate)
        usdAmount = recalcAmount['usdAmount']
        btcAmount = recalcAmount['btcAmount']
    }

    usdAmountBox.val(usdAmount)
    btcAmountBox.val(btcAmount)

    $('#balance-repay-amount').text(usdAmount);
}

const fiatRepayType = (type) => {
    if (type === FIAT_RECALC_TYPE) {
        $('#fiat-repay-usd-value').val('');
        checkSymbols('fiat-repay-fiat-value');
    }
    if (type === USD_CURRENCY) {
        $('#fiat-repay-fiat-value').val('');
        checkSymbols('fiat-repay-usd-value');
    }
    fiatRepayCalcType = type;
    checkUsdAmountValue('fiat');
    setFiatRepayAmount(type);
}

const fiatRepayRecalc = (type) => {
    setFiatRepayAmount(type);
}

const cryptoRepayType = (type) => {
    checkSymbols('crypto-repay-usd-value')
    checkSymbols('crypto-repay-crypto-value')
    if (type === CRYPTO_RECALC_TYPE) {
        $('#crypto-repay-usd-value').val('');
    }
    if (type === USD_CURRENCY) {
        $('#crypto-repay-crypto-value').val('');
    }
    fiatRepayCalcType = type;
    checkUsdAmountValue('crypto');
    setCryptoRepayAmount(type);
}

const cryptoRepayRecalc = (type) => {
    setCryptoRepayAmount(type);
}

const balanceRepayType = (type) => {
    checkSymbols('balance-repay-btc-value');
    checkSymbols('balance-repay-usd-value');
    balanceRepayCalcType = type;
    checkUsdAmountValue('balance');
    balanceRepayRecalc();
}

const hideFiatRequisiteBlock = () => {
    const fiatCurrencies = $('#fiat-repay-select option');
    $.map(fiatCurrencies, function (fiatCurrency) {
        const fiatCurrencyValue = fiatCurrency.value
        if (fiatCurrencyValue) {
            let options = $('#' + fiatCurrencyValue + '-select-fiat-type option');
            $.map(options, function (option) {
                const optionValue = option.value
                $('#requisite-' + optionValue + '-prop').addClass(NON_VISIBLE);
                $('#copy-' + optionValue + '-action').addClass(NON_VISIBLE);
            });

            if (!($('#' + fiatCurrencyValue + '-type-block').hasClass(NON_VISIBLE))) {
                $('#' + fiatCurrencyValue + '-type-block').addClass(NON_VISIBLE);
            }
        }
    });
}

const changeFiatCurrency = () => {
    hideFiatRequisiteBlock();
    setFiatRepayAmount(fiatRepayCalcType);
}

const changeCryptoCurrency = () => {
    hideRepayQrCodeBlock();
    hideBtcOpenInWallet();
    hideCryptoRequisiteBlock();
    setCryptoRepayAmount(cryptoRepayCalcType);
}

const hideRepayQrCodeBlock = () => {
    const repayQrBlock = $('#repay-qr-code-url');
    if (!repayQrBlock.hasClass(NON_VISIBLE)) {
        repayQrBlock.addClass(NON_VISIBLE);
    }
}

const hideBtcOpenInWallet = () => {
    const btcOpenInWallet = OPEN_IN_WALLET_ACTION;
    if (btcOpenInWallet.hasClass(NON_VISIBLE) === false) {
        btcOpenInWallet.addClass(NON_VISIBLE)
    }
}

const confirmBalanceRepay = () => {
    $('#btn-confirm-balance-repay').prop('disabled', true);
    const exchangeRateUpdate = exchangeRates['BTC']['rateUpdated']
    const btcAmount = $('#balance-repay-btc-amount').text();
    const usdAmount = $('#balance-repay-usd-amount').text();
    let data = {
        'amount': btcAmount,
        'usd_amount': usdAmount,
        'from_balance': 1,
        'updated_at': exchangeRateUpdate
    }
    let url = '/repayment';
    sendRepayQuery(url, data);
}

const getFiatCurrency = () => {
    return $("#fiat-repay-select :selected").val();
}

const confirmFiatRepay = () => {
    const fiatCurrency = getFiatCurrency();
    const fiatAmount = $('#fiat-repay-fiat-value').val();
    const usdAmount = $('#fiat-repay-usd-value').val();
    const requisiteVal = $('.requisite-value:not(.d-none)').val();
    const exchangeRateUpdate = getCurrencyRateUpdated(fiatCurrency)
    let data = {
        'repayment_type': repayType,
        'currency': fiatCurrency,
        'amount': fiatAmount,
        'usd_amount': usdAmount,
        'requisite_detail': requisiteVal,
        'updated_at': exchangeRateUpdate
    }
    let url = '/repayment';
    sendRepayQuery(url, data, false);
}

const sendRepayQuery = (url, data, balanceRepay = true) => {
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (result) {
            let errorMsg = 'Something wrong';
            if (result) {
                if (!result.error) {
                    const repaymentUsd = result.repayment_usd,
                        repaymentPercent = result.repayment_percent,
                        repaymentLoan = result.repayment_loan,
                        loanLimitValue = result.loan_limit_value;
                    if (balanceRepay) {
                        showSuccessLoanRepayment(repaymentUsd, repaymentPercent, repaymentLoan, loanLimitValue)
                    } else {
                        showSuccessRequestRepay()
                    }
                } else {
                    if (result.msg) {
                        errorMsg = result.msg;
                    }
                    showToastNotify(TOASTR_ERROR, '', errorMsg)
                }
            }
        }
    });
}

const changeFiatPayOffMethod = () => {
    hideFiatRequisiteBlock()
    setFiatRepayAmount();
}

const activeFields = () => {
    $('#balance-repay-btc-value').focusin(function () {
        $('#balance-repayment-prepend-btc').addClass('info-background');
    });
    $('#balance-repay-btc-value').focusout(function () {
        $('#balance-repayment-prepend-btc').removeClass('info-background');
    });
    $('#balance-repay-usd-value').focusin(function () {
        $('#balance-repayment-prepend-usd').addClass('info-background');
    });
    $('#balance-repay-usd-value').focusout(function () {
        $('#balance-repayment-prepend-usd').removeClass('info-background');
    });
    $('#crypto-repay-usd-value').focusin(function () {
        $('#crypto-repayment-prepend-usd').addClass('info-background');
    });
    $('#crypto-repay-usd-value').focusout(function () {
        $('#crypto-repayment-prepend-usd').removeClass('info-background');
    });
    $('#crypto-repay-crypto-value').focusin(function () {
        $('#crypto-repay-select').addClass('info-background-select');
    });
    $('#crypto-repay-crypto-value').focusout(function () {
        $('#crypto-repay-select').removeClass('info-background-select');
    });

    // $('#fiat-repay-fiat-value').focusin(function () {
    //     $('#fiat-repay-select').addClass('info-background-select');
    // });
    // $('#fiat-repay-fiat-value').focusout(function () {
    //     $('#fiat-repay-select').removeClass('info-background-select');
    // });
    // $('#fiat-repay-usd-value').focusin(function () {
    //     $('#fiat-repayment-prepend-usd').addClass('info-background');
    // });
    // $('#fiat-repay-usd-value').focusout(function () {
    //     $('#fiat-repayment-prepend-usd').removeClass('info-background');
    // });
}

const updateExchangeRates = () => {
    getCurrentRates()
    setBalanceRepayAmount();
    setCryptoRepayAmount(cryptoRepayCalcType);
}

const updateRates = () => {
    if (needUpdate) {
        updateExchangeRates();
    }
}

function generateRepayAddress() {
    const data = {}
    const url = '/repay-address'
    $.ajax({
        type: 'POST',
        url: url,
        data: data,
        success: function (result) {
            let errorMsg = 'Something wrong';
            if (result) {
                if (!result.error && result.address) {
                    $('#crypto-repay-eth-wallet').val(result.address)
                    $('#crypto-repay-usdt-wallet').val(result.address)
                } else {
                    if (result.msg) {
                        errorMsg = result.msg;
                    }
                    showToastNotify(TOASTR_ERROR, '', errorMsg)
                    setInterval(function () {
                        window.location.reload();
                    }, 3 * 1000);
                }
            }
        }
    });
}

$(document).ready(() => {
    repayModalShow();
    checkRepayModalState();
    repayModalHidden();
    successLoanRepaymentModalHidden();
    activeFields();
    updateRates();
    requestRepayModalHidden();
    setInterval(function () {
        updateRates();
    }, 15 * 1000);
})

window.loanRepayment = loanRepayment;
window.showRepayExpand = showRepayExpand;
window.confirmBalanceRepay = confirmBalanceRepay;
window.showConfirmBalanceRepay = showConfirmBalanceRepay;
window.confirmCryptoRepay = confirmCryptoRepay;
window.balanceRepayType = balanceRepayType;
window.balanceRepayRecalc = balanceRepayRecalc;
window.repayRateUpdate = repayRateUpdate;
window.changeCryptoCurrency = changeCryptoCurrency;
window.cryptoRepayRecalc = cryptoRepayRecalc;
window.cryptoRepayType = cryptoRepayType;
window.generateRepayAddress = generateRepayAddress;
